export default {
  id: 92,
  title: 'Target #92 - Squeeze',
  url: 'https://cssbattle.dev/play/92',
  colors: ['#6592CF', '#243D83'],
  solution:
    '<a a><a b><a c><style>[a],[b]{background:#243d83}[c],body{background:#6592cf}[a],[c]{border-radius:9in}a{position:fixed}[a]{width:200;height:200;top:50;left:100;box-shadow:-226px 0 #243d83,226px 0 #243d83}[b]{width:400;height:40;top:130}[c]{width:32;height:32;top:108;left:71;box-shadow:0 52px #6592cf,226px 0 #6592cf,226px 52px #6592cf}</style>',
}
